(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery-2"] && !window.DesignMode) return;
  try {
    
(function(){
  const images = document.querySelectorAll('.mw-image-gallery a');
  const modal = document.querySelector('.mw-modal');
  const modalImage = modal.querySelector('img');
  let currentIndex = 0;
  
  // Open modal popup and show clicked image
  function showModal(index) {
    if(window.innerWidth > 749){
      modalImage.src = images[index].dataset.desktop;
    } else {
      modalImage.src = images[index].dataset.mobile;  
    }    
    modal.classList.add('show');
    currentIndex = index;
  }
  
  // Hide modal popup
  function hideModal() {
    modal.classList.remove('show');
  }
  
  // Show previous image in gallery
  function showPrevImage(e) {
    e.stopPropagation()
    if (currentIndex === 0) {
      showModal(images.length - 1);
    } else {
      showModal(currentIndex - 1);
    }
  }
  
  // Show next image in gallery
  function showNextImage(e) {
    e.stopPropagation()
    if (currentIndex === images.length - 1) {
      showModal(0);
    } else {
      showModal(currentIndex + 1);
    }
  }
  
  // Add click event listeners to all images
  images.forEach((image, index) => {
    image.addEventListener('click', (e) => {
      e.preventDefault()
      showModal(index);
    });
  });  
    
  // Add click event listeners to modal navigation arrows
  const prevArrow = modal.querySelector('.mw-modal-prev');
  prevArrow.addEventListener('click', showPrevImage);
  
  const nextArrow = modal.querySelector('.mw-modal-next');
  nextArrow.addEventListener('click', showNextImage);
  
  // Add click event listener to modal background to hide it
  modal.addEventListener('click', hideModal);

  
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !window.DesignMode) return;
  try {
    
(function(){
  const images = document.querySelectorAll('.mw-image-gallery a');
  const modal = document.querySelector('.mw-modal');
  const modalImage = modal.querySelector('img');
  let currentIndex = 0;
  
  // Open modal popup and show clicked image
  function showModal(index) {
    if(window.innerWidth > 749){
      modalImage.src = images[index].dataset.desktop;
    } else {
      modalImage.src = images[index].dataset.mobile;  
    }    
    modal.classList.add('show');
    currentIndex = index;
  }
  
  // Hide modal popup
  function hideModal() {
    modal.classList.remove('show');
  }
  
  // Show previous image in gallery
  function showPrevImage(e) {
    e.stopPropagation()
    if (currentIndex === 0) {
      showModal(images.length - 1);
    } else {
      showModal(currentIndex - 1);
    }
  }
  
  // Show next image in gallery
  function showNextImage(e) {
    e.stopPropagation()
    if (currentIndex === images.length - 1) {
      showModal(0);
    } else {
      showModal(currentIndex + 1);
    }
  }
  
  // Add click event listeners to all images
  images.forEach((image, index) => {
    image.addEventListener('click', (e) => {
      e.preventDefault()
      showModal(index);
    });
  });  
    
  // Add click event listeners to modal navigation arrows
  const prevArrow = modal.querySelector('.mw-modal-prev');
  prevArrow.addEventListener('click', showPrevImage);
  
  const nextArrow = modal.querySelector('.mw-modal-next');
  nextArrow.addEventListener('click', showNextImage);
  
  // Add click event listener to modal background to hide it
  modal.addEventListener('click', hideModal);

  
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-featured-employee"] && !window.DesignMode) return;
  try {
    
    document.querySelectorAll('.carousel-image').forEach(image => {
    image.addEventListener('click', function() {
        // Cambiar la imagen
        document.getElementById('current-employee-image').src = this.src;

        // Obtener los elementos padre del nombre y trimestre
        const parentDiv = this.parentElement;
        const nameElement = parentDiv.querySelector('#employee-name');
        const quarterElement = parentDiv.querySelector('#employee-quarter');

        // Actualizar el nombre y trimestre actuales
        document.getElementById('current-employee-name').innerHTML = nameElement.innerHTML;
        document.getElementById('current-employee-quarter').innerHTML = quarterElement.innerHTML;
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-page-rental-address"] && !window.DesignMode) return;
  try {
    

  
  
  $(document).ready(function(){

    country = [
       {"id":"1", "name":"México"}, 
       {"id":"2", "name":"Guatemala"},
  //     {"id":"3", "name":"Colombia"},
       {"id":"4", "name":"Chile"}
    ];
  state = [
      {"id":"1","country_id":"1" ,"name":"Chihuahua"},
      {"id":"2","country_id":"1" ,"name":" Baja California"},
      {"id":"3","country_id":"1" ,"name":" Coahuila"},
      {"id":"4","country_id":"1" ,"name":" Ciudad de México y Estado de México"},
      {"id":"5","country_id":"1" ,"name":" Nuevo León"},
      {"id":"7","country_id":"1" ,"name":"Michoacán"},
      {"id":"8","country_id":"1" ,"name":"Querétaro "},
      {"id":"9","country_id":"1" ,"name":"Jalisco"},
      {"id":"10","country_id":"2" ,"name":"Guatemala"},
      {"id":"11","country_id":"3" ,"name":"Bogota"},
     // {"id":"12","country_id":"1" ,"name":"Tamaulipas"},
      {"id":"13","country_id":"1" ,"name":"Quintana Roo"},
      {"id":"14","country_id":"1" ,"name":"Veracruz"},
    //  {"id":"15","country_id":"1" ,"name":"Sinaloa"},
      {"id":"16","country_id":"4" ,"name":"Concepción"},
      {"id":"17","country_id":"1" ,"name":"Hidalgo"},
     // {"id":"18","country_id":"1" ,"name":"Sonora"},
      {"id":"19","country_id":"1" ,"name":"Aguascalientes"},
      {"id":"20","country_id":"1" ,"name":"Durango"}, 
      {"id":"21","country_id":"1" ,"name":"Puebla"},
      {"id":"22","country_id":"1" ,"name":"Yucatán"},
     // {"id":"23","country_id":"1" ,"name":"San Luis Potosí"},
      {"id":"24","country_id":"1" ,"name":"Zacatecas"},
      {"id":"25","country_id":"1" ,"name":"Guanajuato"}

    

    ];
  city = [
      {"id":"1","state_id":"1" ,"name":"Chihuahua"},
      {"id":"2","state_id":"1" ,"name":"Ciudad Juárez"},
     // {"id":"3","state_id":"2" ,"name":"Mexicali"},
      {"id":"4","state_id":"3" ,"name":"Saltillo"},
    //  {"id":"6","state_id":"5" ,"name":"Monterrey"},
     // {"id":"7","state_id":"9" ,"name":" Guadalajara"},
     // {"id":"8","state_id":"7" ,"name":"Tlalpujahua "},
    //  {"id":"9","state_id":"4" ,"name":"Tlalnepantla de Baz"},
      {"id":"10","state_id":"4" ,"name":"Toluca"},
     // {"id":"11","state_id":"5" ,"name":"San Nicolás de los Garza"},
      {"id":"12","state_id":"8" ,"name":"Querétaro"},
      {"id":"13","state_id":"9" ,"name":"Zapopan"}, 
      {"id":"14","state_id":"10" ,"name":"Guatemala"},
      {"id":"15","state_id":"11" ,"name":"Bogota (Los mártires)"},
      {"id":"16","state_id":"5" ,"name":"Apodaca"},
     // {"id":"17","state_id":"1" ,"name":"Hidalgo del Parral"},
      {"id":"18","state_id":"12" ,"name":"Matamoros"},
      {"id":"19","state_id":"7" ,"name":"Morelia"},
      {"id":"20","state_id":"2" ,"name":"Tijuana"},
      {"id":"21","state_id":"13" ,"name":"Cancún"},
      {"id":"22","state_id":"14" ,"name":"Xalapa"},
      {"id":"23","state_id":"15" ,"name":"Culiacán"},
    //  {"id":"24","state_id":"4" ,"name":"Metepec"},
      {"id":"25","state_id":"16" ,"name":"Concepción"},
     // {"id":"26","state_id":"17" ,"name":"Atitalaquia"},
      {"id":"27","state_id":"18" ,"name":"Hermosillo"},
      {"id":"28","state_id":"19" ,"name":"Aguascalientes"},
      {"id":"29","state_id":"20" ,"name":"Gómez Palacio"},
      {"id":"30","state_id":"21" ,"name":"Puebla"},
      {"id":"31","state_id":"4" ,"name":"Nezahualcóyotl"},
      {"id":"32","state_id":"22" ,"name":"Mérida"},
      {"id":"33","state_id":"12","name":"Tampico"},
      {"id":"34","state_id":"17","name":"Ixmiquilpan"},
      {"id":"35","state_id":"23","name":"San Luis Potosí"},
      {"id":"36","state_id":"24","name":"Zacatecas"},
      {"id":"37","state_id":"8" ,"name":"Juriquilla"},
      {"id":"38","state_id":"4","name":"CDMX"},
      {"id":"39","state_id":"4","name":"Naucalpan"},
      {"id":"40","state_id":"8" ,"name":"Tequisquiapan"},
      {"id":"41","state_id":"25" ,"name":"Irapuato"},
      {"id":"42","state_id":"17" ,"name":"Pachuca de Soto"}



     
    ];
  stores =[
     {"id":"1","city_id":"1" ,"name":"Casa Marlá CUU","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/casamarla-map-page.jpg?v=1667514392","map_url":"https://instagram.com/casamarlacuu?igshid=MzRlODBiNWFlZA=="},
     {"id":"5","city_id":"4" ,"name":"Báanal Renta de Vestidos","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/baanal.jpg?v=1673466230","map_url":"https://instagram.com/baanal.mx?igshid=MzRlODBiNWFlZA=="},
     {"id":"6","city_id":"38" ,"name":"Tu Chica Ideal Renta de Vestidos","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/tci-cdmx.jpg?v=1670604227","map_url":"https://instagram.com/tuchicaideal_mx?igshid=MzRlODBiNWFlZA=="},
     {"id":"13","city_id":"10" ,"name":"Vieet Style","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/WhatsApp_Image_2023-01-18_at_12.21.35.jpg?v=1674577061","map_url":" https://instagram.com/vieetstylemx?igshid=MzRlODBiNWFlZA=="},
     //{"id":"14","city_id":"1" ,"name":"Tinto","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/WhatsApp_Image_2023-01-19_at_10.21.43.jpg?v=1674584228","map_url":"https://instagram.com/tintorentadevestidos?igshid=NTdlMDg3MTY="},
     //{"id":"16","city_id":"12" ,"name":"Amelia","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/WhatsApp_Image_2023-01-24_at_11.52.46.jpg?v=1674586442","map_url":"https://instagram.com/ameliacasa_?igshid=MzRlODBiNWFlZA=="},
     //{"id":"18","city_id":"13" ,"name":"Temple","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/WhatsApp_Image_2023-01-20_at_16.57.53.jpg?v=1674851540","map_url":"https://instagram.com/templeboutiquemx?igshid=YmMyMTA2M2Y= "},
     {"id":"19","city_id":"14" ,"name":"AME","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/WhatsApp_Image_2023-01-25_at_10.01.33.jpg?v=1674853360","map_url":"https://instagram.com/wearing.ame"},
     //{"id":"20","city_id":"2" ,"name":"Arabella","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/Arabella-Logo.jpg?v=1674853592","map_url":"https://instagram.com/arabella.jrz?igshid=MzRlODBiNWFlZA=="},
     {"id":"23","city_id":"16" ,"name":"Cocoa Wearhouse","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/23205295-4F4F-40EF-A18D-9455A93B39F5.png?v=1675457997","map_url":"https://instagram.com/cocoawearhouse?igshid=MzRlODBiNWFlZA=="},
     //{"id":"25","city_id":"13" ,"name":"Torres walk in closet","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/WhatsApp_Image_2023-02-02_at_16.20.59.jpg?v=1675460932","map_url":"https://instagram.com/torreswalkincloset?igshid=MzRlODBiNWFlZA=="},
     //{"id":"27","city_id":"12" ,"name":"Amelia wardrobe","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/WhatsApp_Image_2023-02-03_at_16.54.50.jpg?v=1676573687","map_url":"https://www.instagram.com/amelia.wardrobe.mx"},
     {"id":"29","city_id":"r18" ,"name":"Mon Amour Casa de Novias","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/monamour.jpg?v=1677777809","map_url":"https://www.instagram.com/monamour_casadenovias/"},
     {"id":"32","city_id":"20" ,"name":"Adhara Dress Rental","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/332280170_1583736302138730_5056223865738962770_n.jpg?v=1685045324","map_url":"https://www.instagram.com/adharadress/?igshid=YmMyMTA2M2Y%3D"},
     //{"id":"33","city_id":"21" ,"name":"SERENDIPIA","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/WhatsApp_Image_2023-05-16_at_12.39.03_PM.jpg?v=1685046213","map_url":"https://www.instagram.com/serendipia.cancun/?igshid=YmMyMTA2M2Y%3D"}, 
     {"id":"34","city_id":"22" ,"name":"Casa Monserrat","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/WhatsApp_Image_2023-05-16_at_12.41.46_PM.jpg?v=1685047422","map_url":"https://instagram.com/casa.monserrat?igshid=NTc4MTIwNjQ2YQ=="},  
     {"id":"39","city_id":"25" ,"name":"Cherry closet","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/WhatsApp_Image_2023-05-16_at_3.53.29_PM.jpg?v=1685054344","map_url":"https://www.instagram.com/cherry.closet.ccp/ "},
     {"id":"45","city_id":"28" ,"name":"Hortensia","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/unnamed.jpg?v=1689286103","map_url":"https://www.instagram.com/hortensia.ags/ "}, 
     //{"id":"46","city_id":"5" ,"name":"Glow Up","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/WhatsApp_Image_2023-06-30_at_14.24.36.jpg?v=1689286181","map_url":"https://www.instagram.com/glowu.pmx/?igshid=OGQ5ZDc2ODk2ZA%3D%3D "},  
     {"id":"47","city_id":"29" ,"name":"Nala’s","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/WhatsApp_Image_2023-05-29_at_10.54.03.jpg?v=1689286300","map_url":"https://www.facebook.com/profile.php?id=100085594702881&mibextid=LQQJ4d "}, 
     //{"id":"48","city_id":"30" ,"name":"Rosmary","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/WhatsApp_Image_2023-07-05_at_12.35.31.jpg?v=1689286417","map_url":" https://www.instagram.com/rosmaryoficial_/ "},
     {"id":"49","city_id":"31" ,"name":"Dress It Rental","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/WhatsApp_Image_2023-08-18_at_12.24.11_1.jpg?v=1695253609","map_url":"https://instagram.com/dressitrental?igshid=MzRlODBiNWFlZA=="}, 
     //{"id":"50","city_id":"32" ,"name":"Amorela","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/Screenshot_2023-09-20_175824.jpg?v=1695254326","map_url":"https://instagram.com/vestidos_amorela?igshid=MzRlODBiNWFlZA=="},
     //{"id":"51","city_id":"38" ,"name":"Eres una Diosa y Magia","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/WhatsApp_Image_2023-06-20_at_15.17.17_1.jpg?v=1695254326","map_url":"https://instagram.com/eresunadiosaymagia?igshid=MzRlODBiNWFlZA=="},
     //{"id":"52","city_id":"38" ,"name":"Gala Nomada","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/WhatsApp_Image_2023-08-10_at_14.23.50_1.jpg?v=1695254326","map_url":"https://instagram.com/gala.nomada?igshid=MzRlODBiNWFlZA=="},
     {"id":"54","city_id":"34","name":"Folklore Vestidos","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/folklore.jpg?v=1697133682","map_url":"https://instagram.com/folklore_vestidos?igshid=OGQ5ZDc2ODk2ZA=="},
     //{"id":"56","city_id":"32","name":"Telora","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/teolora.jpg?v=1697134115","map_url":"https://instagram.com/telora_mx?igshid=MzRlODBiNWFlZA== "},
     {"id":"57","city_id":"36","name":"Yolia Boutique","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/yolia.jpg?v=1697134447","map_url":"https://instagram.com/yolia_boutique?igshid=MzRlODBiNWFlZA=="},
     {"id":"58","city_id":"40","name":"Amarillo Casa de Vestidos","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/amarillo.jpg?v=1697134571","map_url":"https://www.instagram.com/amarillocasavestidos/"},
     {"id":"58","city_id":"37","name":"LU Dresses House","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/Ludress.jpg?v=1697134666","map_url":"https://instagram.com/ludresseshouse?igshid=MWZjMTM2ODFkZg=="},
     {"id":"59","city_id":"39","name":"Mas que un vestido","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/masque_1.png?v=1701458362","map_url":"https://www.instagram.com/masqueunvestido/?igshid=MzRlODBiNWFlZA%3D%3D"},
     //{"id":"60","city_id":"19","name":"Amorelia","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/amorelia_1.png?v=1701458619","map_url":"https://instagram.com/amorelia_mx?igshid=MzMyNGUyNmU2YQ=="},
     {"id":"61","city_id":"38","name":"E.legance","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/Captura_de_pantalla_2023-12-19_132814.png?v=1703017735","map_url":"https://www.instagram.com/e.legance_cdmx/profilecard/?igsh=MWx5YWxpajR3ZTJwMg%3D%3D"},
     //{"id":"62","city_id":"41","name":"Soona","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/Captura_de_pantalla_2024-01-03_115849.png?v=1704308344","map_url":"https://instagram.com/soona.gto?igshid=NGVhN2U2NjQ0Yg=="},
     //{"id":"63","city_id":"21","name":"Sada Dress","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/Captura_de_pantalla_2023-12-19_133433.png?v=1703018091","map_url":"https://www.instagram.com/sadadress/"},
     {"id":"64","city_id":"32","name":"Luna Glam","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/Captura_de_pantalla_2024-01-03_115450.png?v=1704308251","map_url":"https://www.instagram.com/lunaglam_mid/?igshid=OGQ5ZDc2ODk2ZA%3D%3D"},
     {"id":"65","city_id":"12","name":"Dream Night","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/Captura_de_pantalla_2024-01-12_144857.png?v=1705096208","map_url":"https://www.instagram.com/dreamnightqro?igsh=MWUwcXFwODdyOXpqdw%3D%3D&utm_source=qr"},
     //{"id":"66","city_id":"36","name":"Jero Dress","logo":"https://cdn.shopify.com/s/files/1/0609/6460/2019/files/Imagen_de_WhatsApp_2024-02-09_a_las_09.23.30_5bd66dd5.jpg?v=1707502059","map_url":"https://www.instagram.com/jero.dress/?igshid=OGQ5ZDc2ODk2ZA%3D%3D"},
     //{"id":"67","city_id":"38","name":"Dressing Queen","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/Imagen_de_WhatsApp_2024-02-12_a_las_10.29.25_dbc5fa3e.jpg?v=1707761585","map_url":"https://www.instagram.com/p/C3JZkpNONDU/?igsh=MTRiMHh5OXZjemQ1cg=="},
     //{"id":"68","city_id":"38","name":"Dahlia Boutique","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/b2d49a4a-a6b1-435c-b0e8-313df3988d14.jpg?v=1710191749","map_url":"https://maps.app.goo.gl/CUVBPJ6VJ36XsAwaA?g_st=iw"},
     {"id":"69","city_id":"42","name":"MORENA MÍA","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/imagen_2024-03-25_163718310.png?v=1711406241","map_url":"https://maps.app.goo.gl/C3PYHKc5f8mUfMqn7"},
     {"id":"70","city_id":"38","name":"Laira Boutique","logo":"https://cdn.shopify.com/s/files/1/0501/8858/3107/files/laira-boutique.jpg?v=1738175081","map_url":"https://www.instagram.com/boutique.laira/"}

  ];
 //{"id":"","city_id":"" ,"name":"","logo":"","map_url":""},       
      
    $.each(country, function(i, option) {
        $('#country').append($('<option/> ').attr("value", option.id).text(option.name));
    });

    $(document).on('change', '#country', function(){
       $('#state').html('<option value="0" >Selecciona un estado</option>');
       $('#city').html('<option value="0" >Selecciona una ciudad</option>');
       $('#stores').html('');
       var country_id = $(this).val();
       $.each(state, function(i, option) {
         if(country_id == option.country_id){
           $('#state').append($('<option/> ').attr("value", option.id).text(option.name));
         }
         });     
 
    });

    $(document).on('change', '#state', function(){
       $('#city').html('<option value="0">Selecciona una ciudad</option>');
       $('#stores').html('');
       var state_id = $(this).val();
      /*$.each(stores, function(i, option) {
         if(state_id == option.city_id){
          $('#stores').append('<div class="col-12 col-sm-6 col-lg-4 store-card">'+
                               '<a href="'+option.map_url+'">'+
                               '<img src="'+option.logo +'"/>'+
                               '<p class="store-card-info">'+ option.name +'</p>'+
                               '</a>'+              
            '</div>' );
         }
         }); */
       $.each(city, function(i, option) {
         if(state_id == option.state_id){
           $('#city').append($('<option/>').attr("value", option.id).text(option.name));
         }
         });     
    });

    

    $(document).on('change', '#city', function(){
       $('#stores').html('');
       var city_id = $(this).val();
       $.each(stores, function(i, option) {
         if(city_id == option.city_id){
           $('#stores').append('<div class="col-12 col-sm-6 col-lg-4 store-card">'+
                               '<a href="'+option.map_url+'">'+
                               '<img src="'+option.logo +'"/>'+
                               '<p class="store-card-info">'+ option.name +'</p>'+
                               '</a>'+
                               '</div>'
                               );
         }
         });     
 
    });
    
 });

  } catch(e) { console.error(e); }
})();
})();
